'use strict'

module.exports = require('./js')



//////////////////
// WEBPACK FOOTER
// ./~/iframe-resizer/index.js
// module id = 1214
// module chunks = 1